import React, { useState } from 'react';
import { Skeleton } from 'antd';
import { Route, Switch } from 'react-router-dom';

import Resources from './components/Resources/Resources';
import Summary from './components/Summary/Summary';

import { buildPIPSummaryUri, buildPIPResourcesUri } from 'utils/routes';

const InvestmentPortfolio = ({ isLoading, summaryPersonalInfo, investmentPortfolioDetails }) => {
  const { goalSetting, assumptionInfo, resources, summaryInfo } = investmentPortfolioDetails;
  const [showManageGoalModal, setShowManageGoalModal] = useState(false);

  return (
    <Switch>
      <Route path={buildPIPSummaryUri()}>
        {isLoading ? (
          <Skeleton active />
        ) : (
          <Summary
            personalInfo={summaryPersonalInfo}
            goalSetting={goalSetting}
            assumptionInfo={assumptionInfo}
            summaryInfo={summaryInfo}
            showManageGoalModal={showManageGoalModal}
            setShowManageGoalModal={setShowManageGoalModal}
          />
        )}
      </Route>
      <Route path={buildPIPResourcesUri()}>
        <Resources goalSetting={goalSetting} summaryInfo={summaryInfo} resources={resources} setShowManageGoalModal={setShowManageGoalModal} />
      </Route>
    </Switch>
  );
};

export default InvestmentPortfolio;
